module.exports = flarum.core.compat['components/DiscussionList'];